/// <amd-module name="Build/Admin/Pool/Flux" />
import { AgentDefinitionSource } from "Build/Admin/Common/Sources/AgentDefinitionSource";
import { AgentPoolSource } from "Build/Admin/Common/Sources/AgentPoolSource";
import { AgentQueueSource } from "Build/Admin/Common/Sources/AgentQueueSource";
import { JobSource } from "Build/Admin/Common/Sources/JobSource";
import { SecuritySource } from "Build/Admin/Common/Sources/SecuritySource";
import { ServiceEndpointSource } from "Build/Admin/Common/Sources/ServiceEndpointSource";
import { ActionsHub } from "Build/Admin/Pool/Actions/ActionsHub";
import { PoolActionCreator } from "Build/Admin/Pool/Actions/PoolActionCreator";
import { PoolGraphActionsCreator } from "Build/Admin/Pool/Actions/PoolGraphActionCreator";
import { AgentSource } from "Build/Admin/Pool/Sources/AgentSource";
import { ElasticPoolSource } from "Build/Admin/Pool/Sources/ElasticPoolSource";
import { PoolAnalyticsSource } from "Build/Admin/Pool/Sources/PoolAnalyticsSource";
import { StoresHub } from "Build/Admin/Pool/Stores/StoresHub";
import { IVssPageContext } from "VSS/Platform/Context";

export class Flux {
    public actionsHub: ActionsHub;
    public agentSource: AgentSource;
    public agentPoolSource: AgentPoolSource;
    public agentQueueSource: AgentQueueSource;
    public agentDefinitionSource: AgentDefinitionSource;
    public elasticPoolSource: ElasticPoolSource;
    public jobSource: JobSource;
    public poolActionCreator: PoolActionCreator;
    public poolAnalyticsSource: PoolAnalyticsSource;
    public poolGraphActionCreator: PoolGraphActionsCreator;
    public securitySource: SecuritySource;
    public serviceEndpointSource: ServiceEndpointSource;
    public storesHub: StoresHub;

    public constructor(pageContext: IVssPageContext) {
        this.actionsHub = new ActionsHub();
        this.agentSource = new AgentSource(pageContext);
        this.agentPoolSource = new AgentPoolSource(pageContext);
        this.agentQueueSource = new AgentQueueSource(pageContext);
        this.agentDefinitionSource = new AgentDefinitionSource(pageContext);
        this.elasticPoolSource = new ElasticPoolSource(pageContext);
        this.jobSource = new JobSource(pageContext);
        this.securitySource = new SecuritySource(pageContext);
        this.serviceEndpointSource = new ServiceEndpointSource(pageContext);
        this.storesHub = new StoresHub(this.actionsHub);
        this.poolActionCreator = new PoolActionCreator({
            pageContext: pageContext,
            actionsHub: this.actionsHub,
            agentSource: this.agentSource,
            agentPoolSource: this.agentPoolSource,
            agentQueueSource: this.agentQueueSource,
            agentDefinitionSource: this.agentDefinitionSource,
            elasticPoolSource: this.elasticPoolSource,
            jobSource: this.jobSource,
            securitySource: this.securitySource,
            serviceEndpointSource: this.serviceEndpointSource,
            storesHub: this.storesHub
        });
        this.poolAnalyticsSource = new PoolAnalyticsSource("PoolJobAnalytics_ConcurrencyTrend", pageContext);
        this.poolGraphActionCreator = new PoolGraphActionsCreator({
            actionsHub: this.actionsHub,
            pageContext: pageContext,
            poolAnalyticsSource: this.poolAnalyticsSource,
            storesHub: this.storesHub
        });
    }

    public dispose(): void {
        this.poolActionCreator.dispose();
    }
}
